import React from 'react';
import { IIconProps } from './utils';

export const Target = ({
  fill = 'currentColor', height = 16, width = 16, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 16 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_8228_29638)">
      <path
        d="M1.33301 8C1.33301 11.6819 4.31778 14.6667 7.99967 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8C14.6663 4.3181 11.6816 1.33334 7.99967 1.33334C4.31778 1.33334 1.33301 4.3181 1.33301 8Z"
        stroke={fill}
        strokeLinecap="round"
        strokeWidth="1.33333"
      />
      <path
        d="M4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8Z"
        stroke={fill}
        strokeLinecap="round"
        strokeWidth="1.33333"
      />
      <path
        d="M9.33366 8C9.33366 8.73638 8.73671 9.33333 8.00033 9.33333C7.26395 9.33333 6.66699 8.73638 6.66699 8C6.66699 7.26362 7.26395 6.66666 8.00033 6.66666C8.73671 6.66666 9.33366 7.26362 9.33366 8Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_8228_29638">
        <rect
          fill="white"
          height="16"
          width="16"
        />
      </clipPath>
    </defs>
  </svg>
);
